// extracted by mini-css-extract-plugin
export var addToCartButton = "_pz-b";
export var arrowButtonContainer = "_pz-9";
export var arrowButtonIcon = "_pz-a";
export var carouselArrowButton = "_pz-6";
export var carouselElementContainer = "_pz-1";
export var galleryThumbnail = "_pz-d";
export var galleryThumbnailImage = "_pz-e";
export var left = "_pz-7";
export var productDisplayCarouselContainer = "_pz-0";
export var productTileContainer = "_pz-2";
export var productTileImage = "_pz-4";
export var productTileImageContainer = "_pz-3";
export var productTileTitle = "_pz-5";
export var right = "_pz-8";
export var sliderOverflow = "_pz-c";